// Workforce permissions overview — every employee's STORED tier, module grants,
// action flags and managed locations in one call, for /d/hr/permissions.
//
// Read-only. Saving reuses the existing per-employee path in Stores/EmployeeEdit
// (`get-permission-info/{uuid}` + `update-permission-info`) so this screen and the
// employee-edit modal write through exactly the same action, validation and
// full-replacement semantics.

export const FETCH_PERMISSIONS_OVERVIEW =
  "app/EMPLOYEE_PERMISSIONS/FETCH_PERMISSIONS_OVERVIEW";
export const FETCH_PERMISSIONS_OVERVIEW_SUCCESS =
  "app/EMPLOYEE_PERMISSIONS/FETCH_PERMISSIONS_OVERVIEW_SUCCESS";
export const FETCH_PERMISSIONS_OVERVIEW_FAILURE =
  "app/EMPLOYEE_PERMISSIONS/FETCH_PERMISSIONS_OVERVIEW_FAILURE";

// PERMISSION HISTORY — who changed this employee's access, from what to what, and when.
// `available: false` in the response means the audit table's migration has not run yet;
// that is a legitimate answer, not an error.
export const FETCH_PERMISSION_HISTORY =
  "app/EMPLOYEE_PERMISSIONS/FETCH_PERMISSION_HISTORY";
export const FETCH_PERMISSION_HISTORY_SUCCESS =
  "app/EMPLOYEE_PERMISSIONS/FETCH_PERMISSION_HISTORY_SUCCESS";
export const FETCH_PERMISSION_HISTORY_FAILURE =
  "app/EMPLOYEE_PERMISSIONS/FETCH_PERMISSION_HISTORY_FAILURE";
